package org.catharsis.spendtel.feature.presentation.settings

import androidx.compose.runtime.Composable
import androidx.navigation.NavHostController
import org.catharsis.spendtel.feature.presentation.web.WebSettingsScreen

@Composable
actual fun SettingsScreen(navHostController: NavHostController) {
    WebSettingsScreen(navHostController)
}
